import LegalLayout from "@/components/LegalLayout";
import { useLanguage } from "@/App";

export default function CookiePolicy() {
  const { language } = useLanguage();
  const ar = language === "ar";
  return (
    <LegalLayout titleAr="سياسة الكوكيز" titleEn="Cookie Policy">
      <section>
        <h2 className="text-xl font-bold text-white mb-2">{ar ? "1. ما هي الكوكيز" : "1. What Are Cookies"}</h2>
        <p>{ar
          ? "الكوكيز ملفات نصية صغيرة يحفظها المتصفح على جهازك لتذكّر تفضيلاتك وتفعيل وظائف الموقع."
          : "Cookies are small text files stored by your browser to remember preferences and enable site functionality."}</p>
      </section>

      <section>
        <h2 className="text-xl font-bold text-white mb-2">{ar ? "2. الكوكيز التي نستخدمها" : "2. Cookies We Use"}</h2>
        <ul className="list-disc pr-6 space-y-1">
          <li><b>{ar ? "ضرورية" : "Essential"}</b> — session_token (JWT)، {ar ? "لإبقائك مسجلاً." : "to keep you logged in."}</li>
          <li><b>{ar ? "وظيفية" : "Functional"}</b> — {ar ? "تذكر اختيار اللغة (AR/EN)." : "Remembering language (AR/EN)."}</li>
          <li><b>{ar ? "أداء" : "Performance"}</b> — {ar ? "تخزين مؤقت لأداء أفضل." : "Caching for better performance."}</li>
          <li><b>{ar ? "أطراف ثالثة" : "Third-party"}</b> — Google Maps {ar ? "(لخدمات الخرائط)، Stripe (لمعالجة الدفع)." : "(for maps), Stripe (for payments)."}</li>
        </ul>
      </section>

      <section>
        <h2 className="text-xl font-bold text-white mb-2">{ar ? "3. التحكم في الكوكيز" : "3. Managing Cookies"}</h2>
        <p>{ar
          ? "يمكنك تعطيل أو حذف الكوكيز من إعدادات متصفحك. ملاحظة: تعطيل الكوكيز الضرورية قد يمنعك من تسجيل الدخول."
          : "You can disable or delete cookies from your browser settings. Note: disabling essential cookies will prevent login."}</p>
      </section>

      <section>
        <h2 className="text-xl font-bold text-white mb-2">{ar ? "4. لا نستخدم" : "4. We Do Not Use"}</h2>
        <ul className="list-disc pr-6 space-y-1">
          <li>{ar ? "كوكيز إعلانية أو تتبعية لأغراض تسويقية خارجية." : "Advertising or external-marketing tracking cookies."}</li>
          <li>{ar ? "بصمة الجهاز (fingerprinting)." : "Device fingerprinting."}</li>
        </ul>
      </section>

      <section>
        <h2 className="text-xl font-bold text-white mb-2">{ar ? "5. التحديثات" : "5. Updates"}</h2>
        <p>{ar
          ? "قد نحدّث هذه السياسة. سنخطرك بأي تغيير جوهري عبر البريد الإلكتروني أو إشعار داخل الموقع."
          : "We may update this policy. Material changes will be communicated by email or in-product notice."}</p>
      </section>
    </LegalLayout>
  );
}
